module.exports = __webpack_public_path__ + "img/myposition_cf.a240720d.svg";